import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import preNextPage from './preNextPage'
import appStore from './appStore'
import newPack from './newPack'
import guidedPack from './guidedPack'
import vasWorkbench from './vasWorkbench'
import rfid from './rfid'
import dimensionLimit from './dimensionLimit'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    mutations,
    preNextPage,
    appStore,
    newPack,
    guidedPack,
    vasWorkbench,
    rfid,
    dimensionLimit
  },
  getters,
  actions
})

export default store
